// update the cart count on every page load. to support catching

$(document).ready(function() {

  $.ajax({
    url: "/get-cart-count/",
    method: "GET",
    success: function(resp) {
      // Update cart count
      if ( resp > 99) {
        resp = '99+';
      };
      $(".cart-count").html( resp );
    }
  });

});
